import DialogWrapper from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

export type DialogProps = {
  open: boolean;
  children?: JSX.Element;
  title?: string;
  closeDialog: () => void;
};

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: '620px',
    borderRadius: '8px',
    padding: '25px 35px 25px 35px',
  },
  dialogTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '30px',
    marginBottom: '10px',
  },
  dialogTitle: {
    padding: '10px',
    maringLeft: '10px',
  },
  cancelIcon: {
    cursor: 'pointer',
  },
}));

export const Dialog: React.FC<DialogProps> = ({
  open,
  children,
  title,
  closeDialog,
}) => {
  const classes = useStyles();

  return (
    <DialogWrapper
      classes={{ paper: classes.dialog }}
      open={open}
      onClose={closeDialog}
      aria-labelledby="dialog-title">
      <div className={classes.dialogTitleWrapper}>
        <SvgIcon className={classes.cancelIcon} onClick={closeDialog}>
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
        </SvgIcon>
        <DialogTitle id="dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
      </div>
      {children}
    </DialogWrapper>
  );
};
